/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemLink } from "./d-theme-white-menu-item-link";

export class DThemeWhiteMenuSidedItemLink extends DThemeWhiteMenuItemLink {}
